module.exports = __webpack_public_path__ + "assets/images/a3cbad9c1ef6ba4f2bc2096e0da9f204.jpg";